import { render, staticRenderFns } from "./StudioCommunity.vue?vue&type=template&id=18326cb1&scoped=true&"
import script from "./StudioCommunity.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunity.vue?vue&type=style&index=0&id=18326cb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18326cb1",
  null
  
)

export default component.exports